<template>
  <div class="custom-pagination">
    <div class="pagination-info">
      <div class="per-page-info">
        <img src="../assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
        <span>Per page : </span>
        <div class="select-wrapper">
          <b-form-select
            class="per-page-select"
            v-model="perPageLocal"
            :options="pageOptions"
            @change="updatePerPage"
          >
          </b-form-select>
          <i class="icofont icofont-simple-down select-icon"></i>
        </div>
      </div>
      <span class="page-details">Page no. {{currentPage}}</span>
    </div>
    <div class="pagination-actions">
      <button 
        class="pagination-btn" 
        :disabled="currentPage === 1"
        @click="changePage('prev')"
      >
        Previous
      </button>
      <button 
        class="pagination-btn"
        :disabled="currentPage >= totalPages"
        @click="changePage('next')"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationComponent',
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 1
    },
    perPage: {
      type: Number,
      required: true,
      default: 10
    },
    totalItems: {
      type: Number,
      required: true,
      default: 0
    },
    pageOptions: {
      type: Array,
      default: () => [5, 10, 20, 50]
    }
  },
  data() {
    return {
      perPageLocal: this.perPage
    };
  },
  computed: {
    totalPages() {
      console.log(`Calculating total pages: totalItems=${this.totalItems}, perPageLocal=${this.perPageLocal}`);
      return Math.ceil(this.totalItems / this.perPageLocal) || 1;
    }
  },
  watch: {
    perPage(newVal) {
      this.perPageLocal = newVal;
    },
    totalItems(newVal) {
      // Force re-calculation when totalItems changes
      this.$forceUpdate();
    }
  },
  methods: {
    changePage(direction) {
      this.$emit('change-page', direction);
    },
    updatePerPage() {
      this.$emit('update-per-page', this.perPageLocal);
    }
  }
};
</script>

<style scoped>
.custom-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: #FFFFFF;
  margin-top: 0;
  width: 100%;
  border-top: 1px solid #E5E7EB;
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.per-page-info {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 10px;
  padding: 3px 16px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  font-weight: 500;
}

.per-page-icon {
  width: 16px;
  height: 18px;
  margin-right: 8px;
}

.select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.per-page-select:focus {
  box-shadow: none;
  outline: none;
}

.select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
}

.page-details {
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  font-weight: 500;
}

.pagination-actions {
  display: flex;
  gap: 12px;
}

.pagination-btn {
  padding: 10px 16px;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: all 0.2s ease;
}

.pagination-btn:hover:not(:disabled) {
  background: #F9FAFB;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .custom-pagination {
    flex-direction: column;
    gap: 15px;
    padding: 15px;
  }
  
  .pagination-info,
  .pagination-actions {
    width: 100%;
    justify-content: space-between;
  }
}
</style>